import ajax from '@/resources/myApi';

export const service = {
    getNDCsDetailsRecords,
};


//get reference drug NDCs details 
async function getNDCsDetailsRecords
    (
        pageNumber,
        pageSize,
        sortOrder,
        sortBy,
        filters
    ) {

    const params = {
        pageNumber,
        pageSize,
        sortOrder,
        sortBy,
        filters
    };

    try {
        const { data } = await ajax.get('api/ReferenceDrugHeader/GetReferenceDrugNDCsList', {
            params
        });

        return data;

    } catch (error) {
        return {};
    }
}


export default service;